<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="bg-gray px-2 py-1 h-100 scrollable-container mb-5">
          <div class="card bg-transparent mt-3 rounded border-0">
            <div class="card-body">
              <!-- Label and Add Button -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="text-dark mb-1 fw-bold marketplace-toolbar-title">Membership Plan</label>

               <!-- Only show when there ARE memberships -->
              <div class="d-flex gap-2" v-if="memberships && memberships.length">
                <!-- Medium & up: open modal -->
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-none d-sm-inline-flex"
                  data-bs-toggle="modal"
                  data-bs-target="#create_membership"
                  @click="open_create_membership_modal"
                  aria-label="Open create membership modal"
                >
                  Create Membership
                </button>

                <!-- Small screens only: open full-height offcanvas/sheet -->
                <button
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm d-inline-flex d-sm-none"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#create_membership_sheet"
                  aria-controls="create_membership_sheet"
                  @click="open_create_membership_modal"
                >
                  + Add
                </button>
              </div>
            </div>


            <!-- Tab content -->
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade active show" id="pills-subscriptions" role="tabpanel"
                aria-labelledby="pills-subscriptions-tab">

                <div v-if="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Membership List...</p>
            </div>
            <div v-else>
                <!-- Cards row -->
                <div v-if="memberships && memberships.length" class="row mt-4">
                  <div class="col-12 col-md-4 col-xl-3 mb-2" v-for="(membership, index) in memberships" :key="membership.id">
                    <div class="marketplace-product-card marketplace-product-card-compact d-flex flex-column">
                      <div class="card-body membership-card-border p-3 d-flex flex-column text-start marketplace-card-body">
                        <!-- Top section -->
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="d-flex align-items-center gap-2">
                            <div>
                              <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                <h5 class="fw-bold mb-0">{{membership?.membership_type?.name}}</h5>
                                <span
                                  class="badge rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1 text-xxs fw-500"
                                  :class="membership.is_active ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                                >
                                  <i class="bi bi-circle-fill text-xxxs"></i>
                                  {{ membership.is_active ? 'Active' : 'Inactive' }}
                                </span>
                              </div>
                                <small class="text-muted text-xxs" :title="membership.description">
                                  {{ membership.description?.length > 100 
                                    ? membership.description.substring(0, 100) + '...' 
                                    : membership.description 
                                  }}
                                </small>
                              </div>
                          </div>
                          <div class="dropdown">
                            <button
                              class="btn btn-sm btn-link p-0 text-muted"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              aria-label="Membership actions"
                            >
                              <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li>
                                <button
                                  class="dropdown-item text-xxs"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#create_membership"
                                  @click.prevent="editMembership(membership)"
                                >Edit
                                </button>
                              </li>
                              <li>
                                <button
                                  class="dropdown-item text-xxs text-danger"
                                  type="button"
                                  @click="delete_membership(membership.id)"
                                >Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <!-- Grouped Info -->
                        <div class="membership-info mt-2 mb-3 d-flex flex-column gap-2">
                          <div>
                            <h4 class="fw-bold text-primary mb-0">
                              {{
                                (membership.membership_pricing || []).length > 0
                                  ? 'R ' + Number(membership.membership_pricing[0].price)
                                      .toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                  : 'N/A'
                              }}
                              <small class="text-muted text-xxs">/{{ membership.billing_cycle?.name || '' }}</small>
                            </h4>
                          </div>
                          <div class="d-flex align-items-center gap-2 text-muted text-xxs">
                            <i class="bi bi-people"></i>
                            <span>{{ (total_paid_users[membership.id] || 0).toLocaleString('en-ZA') }} subscribers</span>
                          </div>

                          <div class="border-top pt-1 pb-2 px-1">
                            <div class="fw-bold small mb-1">
                              Perks & Benefits
                            </div>
                            <div>
                              <ul class="list-unstyled mb-0">
                                <li v-if="membership.membership_perks && membership.membership_perks.length"
                                    v-for="perk in membership.membership_perks"
                                    :key="perk.id"
                                    class="mb-1 text-xxs">
                                  <i class="bi bi-check-circle-fill text-primary me-1"></i>
                                  {{ perk.perk.name }}
                                </li>
                                <li v-else class="text-muted text-xxs fst-italic align-items-center text-center mt-2">
                                  No perks added
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <!-- Action Buttons -->
                         <div class="d-flex flex-wrap gap-1 ads-center-card-actions">
                            <button
                              class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill"
                              @click="toggleMembership(membership)"
                            >
                              <i
                                class="bi me-1"
                              ></i>
                              {{ membership.is_active ? 'Deactivate' : 'Activate' }}
                            </button>
                            <button
                              type="button"
                              class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill"
                              @click.stop="open_manage_membership_modal(membership)"
                            >
                              Manage
                            </button>
                         </div>
                        <div class="d-none row g-2 align-items-center">

                          <!-- Activate -->
                          <div class=" col-6 col-sm-auto">
                            <button
                              class="btn btn-sm rounded px-2 text-xxs w-100"
                              :class="membership.is_active ? 'btn-outline-danger' : 'btn-outline-success'"
                              @click="toggleMembership(membership)"
                            >
                              <i
                                class="bi me-1"
                                :class="membership.is_active ? 'bi-pause-circle' : 'bi-play-circle'"
                              ></i>
                              {{ membership.is_active ? 'Deactivate' : 'Activate' }}
                            </button>
                          </div>

                          <!-- View Details -->
                          <div class="col-6 col-sm-auto">
                            <button
                              class="btn btn-sm btn-primary rounded px-2 text-xxs w-100"
                              @click="$router.push('view_membership_users/' + membership.id)"
                            >
                              View Details
                            </button>
                          </div>

                          <!-- Manage Perks -->
                          <div class="col-12 col-sm-auto">
                            <button
                              class="btn btn-sm btn-outline-secondary rounded px-2 text-xxs w-100"
                              data-bs-toggle="modal"
                              data-bs-target="#manage_perks_modal"
                              @click="open_manage_perks_modal(membership.id)"
                            >
                              Manage Perks
                            </button>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <!-- Empty state (only when no memberships) -->
                <div v-else class="text-center py-5 border rounded-3 bg-white">
                  <i class="bi bi-inbox fs-1 text-muted d-block mb-2" aria-hidden="true"></i>
                  <div class="mb-1">No memberships yet</div>
                  <div class="small text-muted mb-2">Create a membership to get started.</div>
                  <button class="btn btn-primary btn-sm text-xxs"
                          data-bs-toggle="modal" data-bs-target="#create_membership"
                          @click="open_create_membership_modal">
                    Create Membership
                  </button>
                </div>
            </div>

                <!-- End cards row -->

              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- Modal for Creating Membership -->
        <div class="modal fade" id="create_membership" tabindex="-1" aria-labelledby="createMembershipLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
            <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
              <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
                <div class="w-100 text-center">
                  <p class="modal-title text-xxs fw-500 mb-0">{{ editing_membership_id ? 'Update Membership' : 'Create Membership' }}</p>
                </div>
                <button
                  type="button"
                  class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i class="fas fa-times fs-6"></i>
                </button>
              </div>
              <form @submit.prevent="submit_membership_form">
                <div class="modal-body modal-body-scroll">
                   <!-- Membership Type -->
                  <div class="mb-3">
                    <label for="membership_type" class="form-label text-xxs fw-500">
                      Membership Type <span class="text-danger">*</span>
                    </label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        id="membership_type"
                        v-model="membership_type"
                        placeholder="Type or select a membership type"
                        :disabled="Boolean(editing_membership_id)"
                        @focus="show_membership_type_dropdown = true"
                        @input="on_membership_type_input"
                        @blur="show_membership_type_dropdown = false"
                        autocomplete="off"
                      />
                      <ul
                        class="dropdown-menu w-100 max-h-200"
                        :class="{ show: !editing_membership_id && show_membership_type_dropdown && get_filtered_membership_types(membership_type).length }"
                        v-if="!editing_membership_id && show_membership_type_dropdown"
                      >
                        <li
                          v-for="type in get_filtered_membership_types(membership_type)"
                          :key="type.id"
                        >
                          <button
                            class="dropdown-item text-xxs"
                            type="button"
                            @mousedown.prevent="select_membership_type(type)"
                          >
                            {{ type.name }}
                          </button>
                        </li>
                      </ul>
                    </div>

                    <!-- Error display -->
                    <p v-if="errors.membership_type" class="text-danger text-xxs">
                      {{ errors.membership_type }}
                    </p>
                  </div>
                  <!--Description-->
                  <div class="mb-3">
                    <label for="membership_description" class="form-label text-xxs fw-500">Description</label>
                    <textarea class="form-control rounded text-xxs" id="membership_description"
                      v-model="membership_description" placeholder="Enter description"></textarea>
                  </div>

                  <!-- Membership Pricing -->
                  <div class="mb-3">
                    <label for="membership_price" class="form-label text-xxs fw-500">
                      Membership Price <span class="text-danger">*</span>
                    </label>
                    <input type="number" class="form-control rounded text-xxs" id="membership_price"
                      v-model="membership_price" placeholder="Enter price" min="0"
                      :disabled="editing_membership_id && total_paid_users[editing_membership_id]">
                    <p v-if="errors.membership_price" class="text-danger text-xxs">{{ errors.membership_price
                      }}</p>
                  </div>

                  <!-- Biliiling cycle -->
                  <div class="mb-3">
                    <label for="billing_cycle" class="form-label text-xxs fw-500">
                      Billing type choices <span class="text-danger">*</span>
                    </label>
                    <select class="form-select rounded text-xxs" id="billing_cycle" v-model="billing_cycle">
                      <option selected hidden>Select membership type</option>
                      <option v-for="billing_cycle in billing_cycle_choices" :key="billing_cycle.id"
                        :value="billing_cycle.id">
                        {{ billing_cycle.name }}
                      </option>
                    </select>
                    <p v-if="errors.billing_cycle" class="text-danger text-xxs">{{ errors.billing_cycle
                      }}</p>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary text-xxs rounded">
                    {{ editing_membership_id ? 'Update Membership' : 'Create' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Mobile offcanvas sheet (shown on <992px) -->
        <div class="offcanvas offcanvas-bottom h-100 d-lg-none" tabindex="-1" id="create_membership_sheet"
            aria-labelledby="createMembershipSheetLabel">
          <div class="offcanvas-header bg-primary text-white">
            <p id="createMembershipSheetLabel" class="mb-0 text-xxs text-white fw-500">Create Membership</p>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>

          <form @submit.prevent="createMembership">
            <div class="offcanvas-body">
              <!-- Name -->
              <div class="mb-3">
                <label for="membership_name_m" class="form-label text-xxs fw-500">
                  Membership Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control rounded text-xxs" id="membership_name_m"
                      v-model="membership_name" placeholder="Enter membership name">
                <p v-if="errors.membership_name" class="text-danger text-xxs">{{ errors.membership_name }}</p>
              </div>

              <!-- Description -->
              <div class="mb-3">
                <label for="membership_description_m" class="form-label text-xxs fw-500">Description</label>
                <textarea class="form-control rounded text-xxs" id="membership_description_m"
                          v-model="membership_description" placeholder="Enter description"></textarea>
              </div>

              <!-- Membership Type -->
              <div class="mb-3">
                <label for="membership_type_m" class="form-label text-xxs fw-500">
                  Membership Type <span class="text-danger">*</span>
                </label>
                <div class="position-relative">
                  <input
                        type="text"
                        class="form-control rounded text-xxs"
                        id="membership_type_m"
                        v-model="membership_type"
                    placeholder="Type or select a membership type"
                    @focus="show_membership_type_dropdown = true"
                    @input="on_membership_type_input"
                    @blur="show_membership_type_dropdown = false"
                    autocomplete="off"
                  >
                  <ul
                    class="dropdown-menu w-100 max-h-200"
                    :class="{ show: show_membership_type_dropdown && get_filtered_membership_types(membership_type).length }"
                    v-if="show_membership_type_dropdown"
                  >
                    <li
                      v-for="type in get_filtered_membership_types(membership_type)"
                      :key="type.id"
                    >
                      <button
                        class="dropdown-item text-xxs"
                        type="button"
                        @mousedown.prevent="select_membership_type(type)"
                      >
                        {{ type.name }}
                      </button>
                    </li>
                  </ul>
                </div>
                <p v-if="errors.membership_type" class="text-danger text-xxs">{{ errors.membership_type }}</p>
              </div>

              <!-- Price -->
              <div class="mb-3">
                <label for="membership_price_m" class="form-label text-xxs fw-500">
                  Membership Price <span class="text-danger">*</span>
                </label>
                <input type="number" class="form-control rounded text-xxs" id="membership_price_m"
                      v-model="membership_price" placeholder="Enter price" min="0">
                <p v-if="errors.membership_price" class="text-danger text-xxs">{{ errors.membership_price }}</p>
              </div>

              <!-- Billing -->
              <div class="mb-3">
                <label for="billing_cycle_m" class="form-label text-xxs fw-500">
                  Billing type choices <span class="text-danger">*</span>
                </label>
                <select class="form-select rounded text-xxs" id="billing_cycle_m" v-model="billing_cycle">
                  <option selected hidden>Select membership type</option>
                  <option v-for="billing_cycle in billing_cycle_choices" :key="billing_cycle.id" :value="billing_cycle.id">
                    {{ billing_cycle.name }}
                  </option>
                </select>
                <p v-if="errors.billing_cycle" class="text-danger text-xxs">{{ errors.billing_cycle }}</p>
              </div>
            </div>

            <!-- Sticky footer actions for thumb reach -->
            <div class="border-top p-2">
              <button type="submit" class="btn btn-primary w-100 text-xxs rounded">Create Membership</button>
            </div>
          </form>
        </div>

        <div class="modal fade" id="manage_perks_modal" tabindex="-1" aria-labelledby="manage_perks_modal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
            <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
              <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
                <div class="w-100 text-center">
                  <p class="modal-title text-xxs fw-500">Manage Perks</p>
                </div>
                
                <button
                  type="button"
                  class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i class="fas fa-times fs-6"></i>
                </button>
              </div>
              <div class="modal-body">
                <label class="form-label mb-3 text-xxs">Perk Name</label>

                <div class="d-flex align-items-stretch gap-3 mb-3">
                  <input
                    type="text"
                    class="form-control rounded text-xxs"
                    v-model="new_perk_name"
                    placeholder="Earn Starbucks Coffee"
                    @keyup.enter="add_perk_input"
                  >
                  <button
                    type="button"
                    class="btn btn-primary btn-sm text-xxs rounded px-4"
                    @click="add_perk_input"
                  >
                    Add
                  </button>
                </div>

                <div class="border rounded p-3 bg-gray">
                  <div v-if="membership_perks.length > 0">
                    <div v-for="(perk, index) in membership_perks" :key="index" class="d-flex align-items-stretch gap-3 mb-3">
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        v-model="perk.perk"
                        placeholder="Earn Starbucks Coffee"
                      >
                      <button
                        type="button"
                        class="btn btn-danger btn-sm text-xxs rounded"
                        @click="remove_perk(index)"
                      >
                        Remove
                      </button>
                    </div>
                  </div>

                  <div v-else>
                    <p class="text-muted text-xxs mb-0 text-center">No perks available.</p>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm text-xxs rounded" @click="save_perks_function">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          id="manage_membership_modal"
          tabindex="-1"
          aria-labelledby="manageMembershipModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header border-0 shadow-sm">
                <div class="w-100 text-center">
                  <p class="modal-title text-xxs fw-500 mb-0">Manage Membership</p>
                </div>
                <button
                  type="button"
                  class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  @click="close_manage_membership_modal"
                ><i class="fas fa-times fs-6"></i>
              </button>
              </div>

              <div class="modal-body manage-product-modal-body modal-body-scroll">
                <div class="row g-4 align-items-start" v-if="selected_manage_membership">
                  <div class="col-12 col-lg-5">
                    <div class="border rounded-4 p-3 bg-light-subtle">
                      <div>
                        <div class="d-flex align-items-center gap-3 mb-4">
                          <div
                            class="d-flex align-items-center justify-content-center rounded-circle bg-light text-primary flex-shrink-0 image-preview-box"
                          >
                            <i class="bi bi-gem fs-4"></i>
                          </div>
                          <div>
                            <h4 class="fw-bold mb-1">
                              {{ selected_manage_membership?.membership_type?.name || selected_manage_membership?.name }}
                            </h4>
                          </div>
                        </div>

                        <p class="text-muted text-xxs lh-lg mb-4">
                          {{ selected_manage_membership.description || 'No description added yet.' }}
                        </p>

                        <div class="mb-4">
                          <h3 class="fw-bold text-primary mb-0">
                            {{
                              (selected_manage_membership.membership_pricing || []).length > 0
                                ? 'R ' + Number(selected_manage_membership.membership_pricing[0].price).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : 'N/A'
                            }}
                            <small class="text-muted text-xxs fw-normal">
                              / {{ selected_manage_membership.billing_cycle?.name || 'Not set' }}
                            </small>
                          </h3>
                        </div>

                        <div class="bg-light rounded-3 px-3 py-3 mt-auto">
                          <div class="d-flex justify-content-between align-items-center text-xxs">
                            <span class="text-muted">Billing type</span>
                            <span class="fw-500 text-dark">{{ selected_manage_membership.billing_cycle?.name || 'Not set' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-7">
                    <div class="border rounded-4 p-3">
                      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                        <div>
                          <h6 class="fw-bold mb-1 text-xxs">Membership details</h6>
                          <p class="text-muted text-xxs mb-0">
                            Review the membership information below.
                          </p>
                        </div>
                      </div>

                      <div class="mt-4">
                        <h6 class="fw-bold mb-3 text-xxs">Membership performance</h6>

                        <div class="border rounded-4 p-3 bg-white d-inline-block mb-4">
                          <div class="row g-3 align-items-center">
                            <div class="col-12">
                              <div class="d-flex align-items-center gap-3 cursor-pointer" @click="open_manage_membership_users(selected_manage_membership)">
                                <div
                                  class="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0 task-chip-tone-7 text-primary small-icon"
                                >
                                  <i class="bi bi-people-fill fs-6"></i>
                                </div>

                                <div>
                                  <div class="text-muted text-xxs fw-semibold mb-1">Subscribers</div>
                                  <div class="fw-bold lh-1 text-primary">
                                    {{ total_paid_users[selected_manage_membership.id] || 0 }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="mb-4">
                          <h6 class="fw-bold mb-2 text-xxs">Membership type</h6>
                          <p class="text-muted mb-0 text-xxs">
                            {{ selected_manage_membership?.membership_type?.name || 'Not set' }}
                          </p>
                        </div>

                        <div class="mb-4">
                          <h6 class="fw-bold mb-2 text-xxs">Status</h6>
                          <p class="text-muted text-xxs mb-0">
                            {{ selected_manage_membership.is_active ? 'Active' : 'Inactive' }}
                          </p>
                        </div>

                        <div class="mb-4">
                          <h6 class="fw-bold mb-2 text-xxs">Description</h6>
                          <p class="text-muted text-xxs mb-0">
                            {{ selected_manage_membership.description || 'No description added yet.' }}
                          </p>
                        </div>

                        <div class="mb-2">
                          <h6 class="fw-bold mb-2 text-xxs">Perks & Benefits</h6>
                          <div class="perk-list-scroll">
                            <ul class="list-unstyled mb-0">
                              <li
                                v-if="selected_manage_membership.membership_perks && selected_manage_membership.membership_perks.length"
                                v-for="perk in selected_manage_membership.membership_perks"
                                :key="perk.id"
                                class="mb-2 text-xxs"
                              >
                                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                                {{ perk.perk.name }}
                              </li>
                              <li v-else class="text-muted text-xxs fst-italic">No perks added</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer border-0 px-4 pb-4 pt-0 gap-3">
                <button
                  type="button"
                  class="btn btn-sm btn-primary rounded text-xxs flex-fill"
                  :disabled="!selected_manage_membership"
                  @click="selected_manage_membership && open_manage_membership_users(selected_manage_membership)"
                >
                  View Details
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-primary rounded text-xxs flex-fill"
                  :disabled="!selected_manage_membership"
                  @click="selected_manage_membership && open_manage_membership_perks(selected_manage_membership)"
                >
                  Manage Perks
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
